import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { Field } from 'react-final-form';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { ITEM_MAX_IMAGE_COUNT } from 'modules/menu/constants';
import ImageView from 'modules/menu/items/components/Item/ItemDetails/ImageView';
import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import { BaseField } from './types';
import { useProductOverridesContext } from '../../../context/ProductOverridesContext';
import { FormRowRenderer } from '../FormRowRenderer';
import { DisplayText, StyledInputContainer, StyledMultiImageUploadInput } from '../OfferDetailsFormFields.styles';
import { BasicDetails } from '../types';

const CatalogImage = styled.img`
  display: block;
  width: 90px;
  border-radius: 8px;
  border: 1px solid ${cbSemanticCssVars.borderPrimary};
  overflow: hidden;
  margin-block-end: 12px;
`;

export const Images = ({ sidePanelMode, offer }: BaseField) => {
  const menuPermissions = useOfferingMenuPermissionsContext();
  const intl = useIntl();
  const { isAttrConnectedToProduct } = useProductOverridesContext();

  const previewComponent =
    !offer?.image && !offer?.images?.length ? <DisplayText>-</DisplayText> : <ImageView item={offer} />;

  const editComponent = (
    <Field<BasicDetails['image']> name="image">
      {({ input }) => {
        return (
          <StyledInputContainer>
            {isAttrConnectedToProduct('image') ? (
              input.value.map(imageField =>
                imageField.type === 'existing-image' ? (
                  <CatalogImage key={imageField.imageUrl} src={imageField.imageUrl} />
                ) : null,
              )
            ) : (
              <StyledMultiImageUploadInput {...input} imageCountLimit={ITEM_MAX_IMAGE_COUNT} showImageGalleryButton />
            )}
          </StyledInputContainer>
        );
      }}
    </Field>
  );

  return (
    <FormRowRenderer
      hasContentEditPermission={menuPermissions.contentEdit}
      label={intl.formatMessage({ id: 'menu-item.image' })}
      previewComponent={previewComponent}
      editComponent={editComponent}
      sidePanelMode={sidePanelMode}
      offer={offer}
      catalogName="image"
    />
  );
};
